import { Stack } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { Switch } from '@repo/foundations';
import type { ChangeEvent } from 'react';
import { DefaultDevDropdown } from './DefaultDevDropdown';
import type { DevPanelItemProps } from './DevPanel';

const REACT_SCAN_TOGGLE = 'reactScanToggle';

export function ReactScanToggle({ close }: DevPanelItemProps) {
	const [reactScanToggle, setReactScanToggle] = useLocalStorage({
		key: REACT_SCAN_TOGGLE,
		defaultValue: false,
	});

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		setReactScanToggle(event.target.checked);
		window.dispatchEvent(new Event('reactScanToggleChanged'));
	};

	return (
		<DefaultDevDropdown label="React Scan" close={close}>
			<Stack>
				<Switch
					label="React Scan"
					checked={reactScanToggle}
					onChange={handleChange}
				/>
			</Stack>
		</DefaultDevDropdown>
	);
}
